import React, { useState } from 'react';
import { Tooltip } from 'antd';
import FullscreenIcon from '../../../component/svgs/new/full-screen.svg';
import FullscreenExitIcon from '../../../component/svgs/new/full-screen-exit.svg';

export interface FullScreenProps {
  text: string;
  tipText: string;
  status: FullScreenStatus | '';
  icon: string;
  hoverIcon: string;
  onClick?: () => void;
}

export enum FullScreenStatus {
  FullScreen = 'FullScreen',
  ExitFullScreen = 'ExitFullScreen'
}

export const getFullScreenButtons = (status: FullScreenStatus | '') => {
  if (status === FullScreenStatus.ExitFullScreen) {
    return {
      text: 'Full Screen',
      tipText: 'Full Screen',
      status,
      icon: 'icon-full-screen',
      hoverIcon: 'icon-full-screen-hover'
    };
  } else if (status === FullScreenStatus.FullScreen) {
    return {
      text: 'Minimize',
      tipText: 'Exit Full Screen',
      status,
      icon: 'icon-full-screen-exit',
      hoverIcon: 'icon-full-screen-exit-hover'
    };
  }
  return null;
};

const FullScreenButton = (props: FullScreenProps) => {
  const { tipText, text, status, hoverIcon, onClick } = props;
  return (
    <Tooltip title={tipText}>
      <button
        onClick={onClick}
        style={{
          ...styles.circleBtn
        }}
        className="press-effect-btn"
        title={text}
      >
        <img
          src={status === FullScreenStatus.FullScreen ? FullscreenExitIcon : FullscreenIcon}
          alt="magic"
          style={{
            width: 18,
            height: 18
          }}
        />
        <span style={styles.btnText}>{text}</span>
      </button>
    </Tooltip>
  );
};

export { FullScreenButton };

const styles = {
  circleBtn: {
    height: '44px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    border: 'none',
    background: 'transparent',
    marginRight: 10
  },
  btnText: {
    marginLeft: 8,
    fontSize: 16,
    color: '#fff',
    fontWeight: '400'
  }
};
